import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from '@angular/router';
import {DepartmentService, OrganizationService, UserService} from '../../apiModule1';

export const usersResolver: ResolveFn<any> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  service: UserService = inject(UserService)) => {
  return service.apiUserGet({}, 'body', false, {transferCache: false});
};
